import { defineStore } from 'pinia';

const playCacheInitValue = {
  key: '',
  context: null,
  rect: {},
  isManuallyStop: false,
  viewportRatio: 0,
};

type SourceContextCacheValue = {
  /** 资源key */
  key: string;
  /** 资源上下文 */
  context: UniApp.VideoContext | null;
  /** 资源节点 */
  rect: UniApp.NodeInfo;
  /** 是否手动停止视频状态 */
  isManuallyStop: boolean;
  /** 可视区域比例面积 */
  viewportRatio: number;
};

interface State {
  resourcesCache: { [key: string]: SourceContextCacheValue };
  playCache: SourceContextCacheValue;
  isWifi: boolean;
}

export const useResourceStore = defineStore('resource', {
  state: (): State => ({
    resourcesCache: {},
    playCache: playCacheInitValue,
    isWifi: false,
  }),

  getters: {},

  actions: {
    judgeWifi() {
      uni.getNetworkType({
        success: (res) => {
          this.isWifi = res.networkType === 'wifi';
          // this.isWifi = true;
        },
        fail: (err) => {
          console.log(err);
        },
      });
    },
    /** 初始化资源信息 */
    initPlayCache() {
      this.playCache = playCacheInitValue;
    },
    /** 开启播放 */
    playSource() {
      // 重新计算获取播放资源
      const cache = this.computePlayCache();

      // 当用户手动停止播放且没有解除状态时，不再播放
      if (cache.isManuallyStop) {
        // 当正在播放的视频可视面积小于40%时，停止播放
        if (this.playCache.viewportRatio < 40) {
          this.playCache.context?.pause();
          // 初始化重置播放数据，防止再次进入可播放状态时，与上一次播放资源信息相同的key。
          this.initPlayCache();
        }
        return;
      }

      // console.log(`上次和这次播放的key${this.playCache.key === cache.key ? '相同' : '不同'}`);
      // 如果两次播放的key相同，则延续之前的播放行为
      if (this.playCache.key === cache.key) return;

      // 如果当前缓存有播放数据，则停止
      if (this.playCache.key) {
        this.playCache.context?.pause();
      }

      // 重新计算获取播放资源
      this.playCache = cache;

      // console.log(this.playCache);

      if (this.playCache.viewportRatio >= 10) {
        this.playCache.context?.play();
      } else {
        this.initPlayCache();
        console.log('进入可视区域小于10%');
      }
    },
    /** 计算需播放的资源信息 */
    computePlayCache() {
      const values = Object.values(this.resourcesCache);

      const _values = values.map((it) => it.viewportRatio);

      const max = Math.max(..._values);

      const target = values.find((it) => it.viewportRatio === max);

      if (target) {
        return target;
      } else {
        console.log('没有在可视区域内的播放器');
        return playCacheInitValue;
      }
    },
    /**
     * 计算进入可视区域的面积百分比
     * @param key - 资源key
     * @param compareHeight - 相对比较的高度
     * @param rect - 资源节点
     */
    computePercent(key: string, compareHeight: number, rect: any) {
      const config: { [key: string]: () => number } = {
        leave: () => {
          let percent = ((compareHeight - rect.bottom) / rect.height) * 100;
          percent = 100 - percent;
          percent = Math.floor(percent < 0 ? 0 : percent);
          // console.log(`离开 => 当前在可视区域面积：${percent}%`);
          return percent;
        },
        into: () => {
          let percent = ((compareHeight - rect.top) / rect.height) * 100;
          percent = Math.floor(percent > 100 ? 100 : percent);
          // console.log(`进入 => 当前在可视区域面积：${percent}%`);
          return percent;
        },
      };
      return config[key]();
    },
  },
});
